import VueRouter from "vue-router";
import navigationGuard from "./navigationGuard";
import routes from "./routes";

const router = new VueRouter({ mode: "history", base: "/", routes });
router.beforeEach(navigationGuard)

export default router